import axios from 'axios';

const api = axios.create({
    baseURL: (process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8001/api/v1').replace(/\/?$/, '/'),
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

export default api;
